/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
// noinspection ES6CheckImport
import {Switch, Route, useHistory, useLocation} from 'react-router-dom';
import {matchPath} from 'react-router';
import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Bussine from './Bussines';
import Data from './Data';
import Orders from './Orders';
import OrderPurchase from './OrderPurchase';
import MyAddress from './MyAddress';
import MyCreditCard from './MyCreditCard';
import Wallet from './Wallet';
import MyProducts from './MyPoriducts';
import {useSelector} from 'react-redux';
import Helmet from '../../components/Helmet';
import Favorites from './Favorites';

function TabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    marginBottom: theme.spacing(4),
  },
  title: {
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  tabs: {
    '& .MuiTabs-indicator': {
      height: 5,
    },
  },
}));

const CustomTab = withStyles((theme) => ({
  root: {
    minHeight: 80,
    border: '0.5px solid rgb(112,112,112, 0.3)',
    backgroundColor: theme.palette.common.white,
    textTransform: 'uppercase',
  },
}))(Tab);

export default function Index() {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const personType = useSelector((state) => state.auth.user?.person_type);
  const ownerCompany = useSelector((state) => state.auth.user?.owner_company);
  const integrationId = useSelector((state) => state.auth.user?.company?.price_list?.integration_id);
  const history = useHistory();
  const location = useLocation();
  const matches = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const getVariant = matches ? 'scrollable' : 'fullWidth';

  const tabs = useMemo(
    () =>
      personType
        ? [
            {
              title: 'Mis datos',
              path: ['/mi-cuenta', '/mi-cuenta/mis-datos'],
              component: Data,
            },
            ...(personType !== 'natural' || ownerCompany === 'true'
              ? [
                  {
                    title: 'Empresa',
                    path: ['/mi-cuenta/empresa', '/mi-cuenta/empresa/usuarios', '/mi-cuenta/empresa/presupuestos'],
                    component: Bussine,
                  },
                ]
              : []),
            {
              title: 'Mis pedidos',
              path: ['/mi-cuenta/mis-pedidos', '/mi-cuenta/mis-pedidos/:id'],
              component: Orders,
            },
            {
              title: 'Ordenes de compra',
              path: ['/mi-cuenta/ordenes-de-compra'],
              component: OrderPurchase,
            },
            ...(integrationId
              ? [
                  {
                    title: 'Mis productos',
                    path: ['/mi-cuenta/mis-productos', '/mi-cuenta/mis-productos/quick-view-:p_id-:p_name'],
                    component: MyProducts,
                  },
                ]
              : []),
            {
              title: 'Favoritos',
              path: ['/mi-cuenta/favoritos'],
              component: Favorites
            },
            {
              title: 'Mis direcciónes',
              path: '/mi-cuenta/mis-direcciónes',
              component: MyAddress,
            },
            {
              title: 'Mis tarjetas de credito',
              path: '/mi-cuenta/mis-tarjetas-de-credito',
              component: MyCreditCard,
            },
            {
              title: 'Cartera',
              path: '/mi-cuenta/cartera',
              component: Wallet,
            },
          ]
        : [],
    [personType],
  );

  const handleChange = (_, newValue) => {
    const tabPath = tabs[newValue].path;
    const newPath = Array.isArray(tabPath) ? tabPath[0] : tabPath;
    history.push(newPath);
    setValue(newValue);
  };

  const matchUrl = (p1, p2) => !!matchPath(p1, {path: p2, exact: true});
  useEffect(() => {
    const index = tabs.findIndex((it) => {
      const path = it.path;
      const isArray = Array.isArray(path);
      if (isArray) {
        return !!path.filter((p) => !!matchUrl(location.pathname, p)).length;
      } else {
        return !!matchUrl(location.pathname, path);
      }
    });
    setValue(index);
  }, [location.pathname, tabs.length]);

  if (!personType) return <div />;

  return (
    <div className={classes.root}>
      <Helmet
        title={'Mi Cuenta'}
        description={''}
        og={{
          url: window.location.href,
          title: 'Estrategias LTDA',
          description: '',
          image: '',
        }}
      />
      <Container maxWidth="xl">
        <Box my={2}>
          <Typography align="center" variant="h2" className={classes.title}>
            Mi cuenta
          </Typography>
        </Box>
        <AppBar elevation={0} position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            className={classes.tabs}
            textColor="inherit"
            variant={getVariant}
            scrollButtons="auto"
          >
            {tabs.map((tab, i) => (
              <CustomTab key={i} label={tab.title} {...a11yProps(i)} />
            ))}
          </Tabs>
        </AppBar>
        <Switch>
          {tabs.map((tab, i) => (
            <Route
              exact
              key={i}
              path={tab.path}
              component={() => (
                <TabPanel index={i} value={i} dir={theme.direction}>
                  {React.createElement(tab.component, {})}
                </TabPanel>
              )}
            />
          ))}
        </Switch>
      </Container>
    </div>
  );
}
